"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useCaptureSnapshot = void 0;
var _useViewpointMarkups = require("../../../../Bridges/ViewpointMarkups/useViewpointMarkups");
var _react = require("react");
var _alloyReactNotification = require("@adsk/alloy-react-notification");
var _issueSnapshots = require("../../../../state/redux/ducks/issueSnapshots");
var _hooks = require("../../../../state/redux/hooks");
var _featureFlags = require("../../../../utils/featureFlags");
var _alloyProvider = require("@adsk/alloy-provider");
var _useTranslations = require("../../../../utils/i18n/useTranslations");
var _issueLinkedDocumentsUtils = require("../../../../utils/data/issueLinkedDocumentsUtils");
const useCaptureSnapshot = () => {
  const {
    takeScreenshot
  } = (0, _useViewpointMarkups.useViewpointMarkups)();
  const dispatch = (0, _hooks.useDispatch)();
  const {
    showNotification
  } = (0, _alloyReactNotification.useNotifications)();
  const {
    T
  } = (0, _useTranslations.useTranslations)();
  const {
    value: displayThumbnailField
  } = (0, _featureFlags.useFeatureFlag)(_featureFlags.FeatureFlag.DisplayIssueThumbnailField);
  const projectId = (0, _alloyProvider.useCurrentProjectId)();
  return (0, _react.useCallback)(async _ref => {
    let {
      issue,
      flowId
    } = _ref;
    if (!projectId || !displayThumbnailField || !takeScreenshot || !(0, _issueLinkedDocumentsUtils.is3dIssue)(issue)) {
      return;
    }
    try {
      dispatch((0, _issueSnapshots.issueSnapshotCaptureStart)({
        issueId: issue.id,
        flowId
      }));
      return takeScreenshot(issue.id);
    } catch (e) {
      dispatch((0, _issueSnapshots.issueSnapshotFailure)({
        issueId: issue.id
      }));
      showNotification({
        status: _alloyReactNotification.NOTIFICATION_STATUSES.ERROR,
        message: T.translate("thumbnailField.failureMessage")
      });
    }
  }, [projectId, displayThumbnailField, takeScreenshot, dispatch, showNotification, T]);
};
exports.useCaptureSnapshot = useCaptureSnapshot;
//# sourceMappingURL=useCaptureSnapshot.js.map